import Cookies from 'js-cookie';

import { writeAttributionCookie } from './cookies';
import { isExcludedEntryPath } from '@lib/checkout/entry-page-exclusions';

/**
 * FFH-1849: the first page the buyer landed on. Written write-once (mirroring
 * `utm_first_touch`) via the shared attribution-cookie writer — apex domain,
 * 30-day, Secure, SameSite=Lax. It is client-set, so Safari ITP caps it to
 * ~7 days; that still covers the vast majority of land→convert windows, and
 * the every-page capture catches all entries (not just `go.` redirects). Read
 * at checkout and carried into subscription metadata + the ChartMogul mirror.
 */
export const FIRST_LANDING_PAGE_COOKIE = 'first_landing_page';

export const recordFirstLandingPage = (pathname: string): void => {
  // Skip internal flow pages (checkout / thank-you / funnel-welcome / auth) so
  // a direct hit into the flow can't seed a non-actionable internal route as
  // the "first landing page" — same exclusions as the checkout-initiating page.
  if (isExcludedEntryPath(pathname)) return;

  writeAttributionCookie(FIRST_LANDING_PAGE_COOKIE, pathname, {
    firstTouch: true
  });
};

export const readFirstLandingPage = (): string | undefined =>
  Cookies.get(FIRST_LANDING_PAGE_COOKIE) || undefined;
